import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Task\UpdateTaskController::__invoke
* @see app/Http/Controllers/Task/UpdateTaskController.php
* @route '/api/task-for-select'
*/
const UpdateTaskController56f03f0b49e165468629d31a28799e1d = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: UpdateTaskController56f03f0b49e165468629d31a28799e1d.url(options),
    method: 'get',
})

UpdateTaskController56f03f0b49e165468629d31a28799e1d.definition = {
    methods: ["get","head"],
    url: '/api/task-for-select',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Task\UpdateTaskController::__invoke
* @see app/Http/Controllers/Task/UpdateTaskController.php
* @route '/api/task-for-select'
*/
UpdateTaskController56f03f0b49e165468629d31a28799e1d.url = (options?: RouteQueryOptions) => {
    return UpdateTaskController56f03f0b49e165468629d31a28799e1d.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Task\UpdateTaskController::__invoke
* @see app/Http/Controllers/Task/UpdateTaskController.php
* @route '/api/task-for-select'
*/
UpdateTaskController56f03f0b49e165468629d31a28799e1d.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: UpdateTaskController56f03f0b49e165468629d31a28799e1d.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Task\UpdateTaskController::__invoke
* @see app/Http/Controllers/Task/UpdateTaskController.php
* @route '/api/task-for-select'
*/
UpdateTaskController56f03f0b49e165468629d31a28799e1d.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: UpdateTaskController56f03f0b49e165468629d31a28799e1d.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Task\UpdateTaskController::__invoke
* @see app/Http/Controllers/Task/UpdateTaskController.php
* @route '/api/task/{task}'
*/
const UpdateTaskController69b7cac8b53844dba3837ada362a8992 = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskController69b7cac8b53844dba3837ada362a8992.url(args, options),
    method: 'put',
})

UpdateTaskController69b7cac8b53844dba3837ada362a8992.definition = {
    methods: ["put"],
    url: '/api/task/{task}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Task\UpdateTaskController::__invoke
* @see app/Http/Controllers/Task/UpdateTaskController.php
* @route '/api/task/{task}'
*/
UpdateTaskController69b7cac8b53844dba3837ada362a8992.url = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { task: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { task: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        task: typeof args.task === 'object'
        ? args.task.id
        : args.task,
    }

    return UpdateTaskController69b7cac8b53844dba3837ada362a8992.definition.url
            .replace('{task}', parsedArgs.task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Task\UpdateTaskController::__invoke
* @see app/Http/Controllers/Task/UpdateTaskController.php
* @route '/api/task/{task}'
*/
UpdateTaskController69b7cac8b53844dba3837ada362a8992.put = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskController69b7cac8b53844dba3837ada362a8992.url(args, options),
    method: 'put',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Task\UpdateTaskController::UpdateTaskController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `UpdateTaskController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const UpdateTaskController = {
    '/api/task-for-select': UpdateTaskController56f03f0b49e165468629d31a28799e1d,
    '/api/task/{task}': UpdateTaskController69b7cac8b53844dba3837ada362a8992,
}

export default UpdateTaskController